'use client';

import { useCallback } from 'react';

import type { FC, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import type { IUserFingerprintData } from 'services/FingerprintService/fingerprint.model';
import { useCheckUserFingerprintData } from 'utils/hooks/query-hooks/useCheckUserFingerprintData';

import { useCollectUserData } from './utils/hooks/useCollectUserData';

interface ICollectUserDataProvider {
  children: ReactNode;
}

export const CollectUserDataProvider: FC<ICollectUserDataProvider> = ({ children }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const invoiceId = currentPath.split('/')[2];

  const { mutate } = useCheckUserFingerprintData();

  const handleUserDataEffect = useCallback(
    (data: IUserFingerprintData) => {
      mutate(data);
    },
    [mutate],
  );

  useCollectUserData({
    conditions: [currentPath.includes('pay')],
    handleUserDataEffect,
    instance_id: invoiceId,
    instance_type: 'invoice',
  });

  return <>{children}</>;
};
